import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderProvider, HomeServiceOrderProviderInput } from '@/models/homeService';

// Fragments
import './fragments/homeServiceOrderProviderFragment';

export const updateHomeServiceOrderProvider = async (id: number, data: HomeServiceOrderProviderInput) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation UpdateHomeServiceOrderProvider($id: Float!, $data: HomeServiceOrderProviderInputType!) {
        updateHomeServiceOrderProvider(id: $id, data: $data) {
          ...HomeServiceOrderProviderFragment
        }
      }
    `),
  });

  return response.data?.updateHomeServiceOrderProvider as HomeServiceOrderProvider;
};
